import React, { useState, useEffect } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import "./Home.css";
import Location from '../images/pin.png'
import telephone from '../images/telephone.png'
import Email from '../images/email.png'
import Logo from '../images/logo.svg'

const Footer = () => {

   const [isScrolled, setIsScrolled] = useState(false);
    const [menuActive, setMenuActive] = useState(false);
    const [dropdownOpen, setDropdownOpen] = useState(false);
  
    const navigate = useNavigate();
  
    const navigateToService = (section) => {
      navigate("/our-services", {
        state: {
          activeSection: section,
        },
      });
  
      setDropdownOpen(false);
      setMenuActive(false);
    };
  
    useEffect(() => {
      const handleScroll = () => {
        setIsScrolled(window.scrollY > 0);
      };
  
      window.addEventListener("scroll", handleScroll);
  
      return () => {
        window.removeEventListener("scroll", handleScroll);
      };
    }, []);
  
    const closeMenu = () => {
      setMenuActive(false);
      setDropdownOpen(false);
    };




  return (
    <footer className="footer">
      <div className="footer-container">

        {/* Company Info */}
        <div className="footer-column">
          <div className="footer-logo">
            <img src={Logo} alt="Total Care Advisory" />
          </div>

          <p>
            Providing specialist consultancy services for care providers,
            healthcare organisations, and social care businesses.
          </p>
        </div>

        {/* Quick Links */}
        <div className="footer-column">
          <h4>Quick Links</h4>
          <nav className={`nav-link ${menuActive ? "active" : ""}`}>

        <NavLink to="/" end onClick={closeMenu}>Home</NavLink>
        <NavLink to="/about" onClick={closeMenu}>About Us</NavLink>
        <NavLink to="/our-services" onClick={closeMenu}>Our Services</NavLink>
        <NavLink to="/insights" onClick={closeMenu}>Insights</NavLink>
        <NavLink to="/faqs" onClick={closeMenu}>FAQs</NavLink>
      </nav>

        </div>

        {/* Services */}
        <div className="footer-column">
          <h4>Services</h4>
          <ul>
            <li onClick={() => navigateToService("cqc-services")}>CQC Services</li>
             <li onClick={() => navigateToService("care-home-sales")}>Care Home Sales</li>
              <li onClick={() => navigateToService("accounting")}>Accounting</li>
             <li onClick={() => navigateToService("software")}>Software</li>
            <li onClick={() => navigateToService("operational-management")}>Operational Management</li>
          </ul>
        </div>

        {/* Contact */}

        <div className="footer-column">
        <h4>Contact Us</h4>

        <div className="contact-item">
            <img src={Location} alt="Location" />
            <p>London, United Kingdom</p>
        </div>

        <div className="contact-item">
            <img src={telephone} alt="Phone" />
            <p>+44 123 456 7890</p>
        </div>

        <div className="contact-item">
            <img src={Email} alt="Email" />
            <p>info@totalcareadvisory.com</p>
        </div>

         <div className="social-icons">
            <a href="#"><i className="fab fa-facebook-f"></i></a>
            <a href="#"><i className="fab fa-linkedin-in"></i></a>
            <a href="#"><i className="fab fa-twitter"></i></a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;